// Calendar-year picks for period filters (Apal 2026-10-09: "a year itself …
// 2021, 2022 etc and dates get selected themselves"). Shared by Signal
// Analysis (Year period) and Quarterly Wins (Closed between).

// The oldest history: the US and European indexes start in 1996.
export const FIRST_DATA_YEAR = 1996;

/** lastYear down to FIRST_DATA_YEAR, newest first. */
export const calendarYears = (lastYear) =>
  Array.from({ length: Math.max(0, lastYear - FIRST_DATA_YEAR + 1) }, (_, i) => lastYear - i);

/** 1 Jan – 31 Dec of `year`, as ISO dates. */
export const yearRange = (year) => ({ from: `${year}-01-01`, to: `${year}-12-31` });

/** The year a from/to pair spans exactly (1 Jan – 31 Dec of one year), else null. */
export const yearOfRange = (from, to) => {
  const m = /^(\d{4})-01-01$/.exec(from || '');
  return m && to === `${m[1]}-12-31` ? Number(m[1]) : null;
};
